interface IBidderTypeMap {
  [key: string]: string;
}
// map the bidder name for cases where the UI needs to display a different name than that which is defined in live logs
export const bidderTypeMap: IBidderTypeMap = {
  iponweb: 'themediagrid',
  verizon: 'yahoo',
  improvedigital: 'azerion',
};

export function mapBidderType(bidder: string): string {
  return bidderTypeMap[bidder] ? bidderTypeMap[bidder] : bidder;
}
